import { randomRange } from "../../../common/common_funcs.js";
import { Game } from "../../../game.js";
import { VfxConfettiBatch } from "./vfx_confetti_batch.js";

export class VfxConfettiSide
{
  public static readonly PARTICLES_PER_BURST : number = 180;

  public static readonly MIN_LIFESPAN        : number = 3200;
  public static readonly MAX_LIFESPAN        : number = 4800;
  public static readonly MIN_START_DELAY     : number = 0;
  public static readonly MAX_START_DELAY     : number = 100;

  public static readonly MIN_DEG_LEFT        : number = 20;
  public static readonly MAX_DEG_LEFT        : number = 80;
  public static readonly MIN_DEG_RIGHT       : number = 100;
  public static readonly MAX_DEG_RIGHT       : number = 160;

  public static readonly MIN_SPEED           : number = 1.5;
  public static readonly MAX_SPEED           : number = 2.8;
  public static readonly MIN_SPIN            : number = -0.005;
  public static readonly MAX_SPIN            : number = 0.005;

  public static readonly MIN_FLUTTER_AMP     : number = 40;
  public static readonly MAX_FLUTTER_AMP     : number = 50;
  public static readonly MIN_FLUTTER_FREQ    : number = 0.002;
  public static readonly MAX_FLUTTER_FREQ    : number = 0.003;

  public static readonly COLOR_PALETTE: ReadonlyArray<[number, number, number]> = [
    [ 1.0, 0.18, 0.24 ], [ 1.0, 0.58, 0.06 ], [ 1.0, 0.9, 0.08 ], [ 0.12, 0.9, 0.36 ],
    [ 0.0, 0.78, 1.0 ], [ 0.38, 0.42, 1.0 ], [ 0.84, 0.24, 1.0 ], [ 1.0, 0.12, 0.72 ],
  ];

  public static burst( batch: VfxConfettiBatch, start_time: number ): void
  {
    const scale = LayoutScaler.getScale();
    const screen_w = Game.getScreenWidth();
    const screen_h = Game.getScreenHeight();

    for ( let i = 0; i < VfxConfettiSide.PARTICLES_PER_BURST; i++ )
    {
      const is_left = i % 2 === 0;
      let spawn_x: number;
      let spawn_y: number;
      let min_deg: number;
      let max_deg: number;

      if ( is_left )
      {
        spawn_x = randomRange( -30, 30 ) * scale;
        spawn_y = screen_h * randomRange( 0.2, 0.6 );
        min_deg = VfxConfettiSide.MIN_DEG_LEFT;
        max_deg = VfxConfettiSide.MAX_DEG_LEFT;
      }
      else
      {
        spawn_x = screen_w + randomRange( -30, 30 ) * scale;
        spawn_y = screen_h * randomRange( 0.2, 0.6 );
        min_deg = VfxConfettiSide.MIN_DEG_RIGHT;
        max_deg = VfxConfettiSide.MAX_DEG_RIGHT;
      }

      const lifespan = randomRange( VfxConfettiSide.MIN_LIFESPAN, VfxConfettiSide.MAX_LIFESPAN );
      const p_start_time = start_time + randomRange( VfxConfettiSide.MIN_START_DELAY, VfxConfettiSide.MAX_START_DELAY );

      const launch_angle = randomRange( min_deg, max_deg ) * Math.PI / 180;
      const speed = randomRange( VfxConfettiSide.MIN_SPEED, VfxConfettiSide.MAX_SPEED ) * scale;

      const vel_x = Math.cos( launch_angle ) * speed;
      const vel_y = -Math.sin( launch_angle ) * speed;

      const color_rgb = VfxConfettiSide.COLOR_PALETTE[
        Math.floor( randomRange( 0, VfxConfettiSide.COLOR_PALETTE.length ) )
      ];

      const angle = randomRange( 0, Math.PI * 2 );
      const spin = randomRange( VfxConfettiSide.MIN_SPIN, VfxConfettiSide.MAX_SPIN );
      const frame_index = Math.floor( randomRange( 0, VfxConfettiBatch.ATLAS_COLS * VfxConfettiBatch.ATLAS_ROWS ) );
      const flutter_phase = randomRange( 0, Math.PI * 2 );
      const flutter_amp = randomRange( VfxConfettiSide.MIN_FLUTTER_AMP, VfxConfettiSide.MAX_FLUTTER_AMP );
      const flutter_freq = randomRange( VfxConfettiSide.MIN_FLUTTER_FREQ, VfxConfettiSide.MAX_FLUTTER_FREQ );

      batch.spawn(
        spawn_x, spawn_y, vel_x, vel_y,
        color_rgb[0], color_rgb[1], color_rgb[2],
        angle, spin, frame_index,
        lifespan, p_start_time,
        flutter_phase, flutter_amp, flutter_freq
      );
    }
  }
}
